(() => {

  /*
   * Evita inicializar os listeners mais de uma vez
   * caso o snippet seja renderizado novamente.
   */
  if (window.NauProductRecommendationsLoaded) {
    return;
  }

  window.NauProductRecommendationsLoaded = true;


  function markRecommendationImages(root = document) {

    root.querySelectorAll('.pr-card__image').forEach((img) => {

      if (img.complete && img.naturalWidth > 0) {

        img.classList.add('loaded');

        return;

      }


      img.addEventListener(
        'load',
        () => img.classList.add('loaded'),
        { once: true }
      );

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => markRecommendationImages()
    );

  } else {

    markRecommendationImages();

  }


  /*
   * Reaplica quando uma seção for recarregada
   * no editor de temas da Shopify.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {

      markRecommendationImages(event.target);

    }
  );

})();